import {
  CancelTicketRequest,
  CancelTicketResponse,
  InitTopUpResponse,
  PayTopUpRequest,
  PayTopUpResponse,
  VerifyUserEmailRequest,
  VerifyUserEmailResponse,
} from '../types';

import { authUrl } from '@/features/login-and-signup/services/config';
import { createMutation } from '@/logic/libs';
import { ordersUrl } from '@/logic/services';
import { topUpUrl } from '../config';

export const useInitTopUp = createMutation<InitTopUpResponse>({
  method: 'post',
  url: topUpUrl,
});

export const usePayTopUp = createMutation<PayTopUpResponse, PayTopUpRequest>({
  method: 'post',
  url: `${topUpUrl}/:topUpId/pay`,
});

export const useCancelTicket = createMutation<CancelTicketResponse, CancelTicketRequest>({
  method: 'post',
  url: `${ordersUrl}/:orderId/cancel`,
});

export const useInitVerifyUserEmail = createMutation<unknown, unknown>({
  method: 'post',
  url: `${authUrl}/init-verify-email-user`,
});

export const useVerifyUserEmail = createMutation<
  VerifyUserEmailResponse,
  VerifyUserEmailRequest
>({
  method: 'post',
  url: `${authUrl}/verify-email-user`,
});
